// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"64a61db3","239":"e1afa1cf","453":"974301cb","455":"8d7555c2"}[chunkId] + ".chunk.js";
};